import styled from "styled-components";

export const TableWrapper = styled.div`
  position: relative;
`

export const Wrapper = styled.div`
  margin: 3% 10%;
  padding-bottom: 3%;
`

export const Table = styled.div`
  text-align: center;

  border: 1px solid rgba(0,0,0,.06);
`

export const AddNewUserButton = styled.button`
  margin-bottom: 10px;
  
  padding: 10px;

  color: #389e0d;
  background: #f6ffed;
  border: 1px solid #b7eb8f;

  cursor: pointer;
`
